import { render, staticRenderFns } from "./ClickAppointment.vue?vue&type=template&id=5eccfe92&"
import script from "./ClickAppointment.vue?vue&type=script&lang=js&"
export * from "./ClickAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports